import styled from '@emotion/styled'

export const MarkdownStyled = styled.div`
  sup {
    position: relative;
    top: -0.5em;
    font-size: 0.7em;
  }
  sub {
    position: relative;
    bottom: -0.5em;
    font-size: 0.7em;
  }
  ul {
    padding-left: 1.2em;
    list-style: inherit;
  }
  ol {
    padding-left: 1.2em;
  }
`
